import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum FirstbasePurchaseOrderLineItemKeys {
  lineNumber = 'lineNumber',
  itemName = 'itemName',
  mpn = 'mpn',
  quantity = 'quantity',
  unitCost = 'unitCost',
  shipmentCost = 'shipmentCost',
  tax = 'tax',
  total = 'total',
}

export const firstbasePurchaseOrderFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateReady: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  destination: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  vendor: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        lineNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        mpn: yup.string().nullable().optional(),
        quantity: yup.string().nullable().optional(),
        tax: yup.string().nullable().optional(),
        unitCost: yup.string().nullable().optional(),
        shipmentCost: yup.string().nullable().optional(),
        total: yup.string().nullable().optional(),
      }),
    )
    .required(),
  shippingCost: yup.string().nullable().optional(),
  tax: yup.string().nullable().optional(),
  total: yup.string().nullable().optional(),
  agreement: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
})

export type FirstbasePurchaseOrderFileData = yup.InferType<
  typeof firstbasePurchaseOrderFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<FirstbasePurchaseOrderFileData>

export const firstbasePurchaseOrderFileMappings: RequiredFileData = {
  issuer: {
    attn: '6eee9035-81da-46de-84b0-f4a9b90f3c00',
    companyName: '945020c9-3dc6-4e14-bf4b-e8c139a26805',
    address: 'fcec3fb3-9d39-41a5-b558-1d925efec75d',
    phoneNumber: 'f629a9e4-a811-4799-9263-058fd888366b',
    emailAddress: 'f9ce2577-10a3-4d92-8191-5146729f30bd',
  },
  orderNumber: '388cbedd-992e-4559-b0c3-ac36829e8246',
  paymentTerms: '5cb41896-3da3-4407-bf72-a6f09099b1de',
  freightTerms: 'b798bb3e-65e0-4524-82a2-bc619d6d0a83',
  dateIssued: 'd6da52ff-fe1c-4236-8b77-90eb05d1ea0e',
  dateReady: '56cc77ab-91c1-4b57-9843-9d7eaf888f29',
  destination: {
    attn: '94aabff5-60e0-4137-8866-9c5e558c7b60',
    companyName: 'd561a298-ddfd-47db-a4cb-557d93fd30ea',
    address: '8e96ad5d-e75b-429b-af9e-a3de22e7151f',
    phoneNumber: '3f5363b1-9761-4625-99f4-b4f7348d08fb',
    emailAddress: '45c52b2b-0172-4332-b06c-36b826b04883',
  },
  vendor: {
    attn: '606ceed8-1f09-4bd0-96e9-d33731bfc593',
    companyName: '4284afdd-d7d1-47f4-bf70-b7469eeaca20',
    address: '7e5a0f6c-96f1-4409-b76a-5443a0c16f2c',
    phoneNumber: '4e611138-e497-492b-9ce9-31d16a8c1444',
    emailAddress: 'ed483e9b-005f-46fc-a28f-4a238df172cb',
  },
  items: [
    {
      lineNumber: null,
      itemName: '20be73f4-3fcc-4483-928b-4b225a9c989d',
      mpn: 'eed1970d-4540-453f-b4a9-eb390300063b',
      quantity: '8d78d213-9c7c-4cda-bafb-13feed9b9626',
      tax: '24d2e856-b2ea-47f6-8150-67bf3cd495b4',
      unitCost: 'dcaa9e2f-54e2-4455-a535-15604ddfb916',
      shipmentCost: 'fb87cca9-3e9a-490d-91f3-da3710ad2b09',
      total: 'a7f8e9d6-5c4b-4a2d-9e0f-9b8c7d6e5f4a',
    },
  ],
  shippingCost: '3b8f9c2e-7d4a-4f1b-9e8d-6c5b4a3d2e1f',
  tax: '4c9e8d7f-6a5b-4c3d-2e1f-8b7a6c5d4e3f',
  total: '5d0f9e8a-7b6c-4d4e-3f2a-9c8b7d6e5f4a',
  agreement: '1f2ab952-9620-454b-a244-531535a206da',
  instructions: 'edbb9e0e-41dd-4ebd-9cca-11df0020d8bf',
}
